import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

interface EventHeaderExpandedPropsType {
    isExpandedSelectionLayout?: boolean;
    dataTest?: string;
}

export const EventHeaderCaptionWrapper = withConfig(theme => styled('div', { label: 'EventHeaderCaptionWrapper' })<EventHeaderExpandedPropsType>`
    display: flex;
    justify-content: flex-end;
    color: ${theme.star.unified.eventHeaderCaption.txtColor};
    padding: ${theme.star.padding.medium} ${theme.star.padding.xMedium};
    background: ${theme.star.unified.eventHeaderCaption.bgColor};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: ${theme.star.lineHeight[200]};
    ${({ isExpandedSelectionLayout = false }): SerializedStyles =>
        isExpandedSelectionLayout === true
            ? css`
                  gap: ${theme.star.gap.small};
              `
            : css``}
`);

export const EventHeaderLabel = withConfig(theme => styled('span', { label: 'EventHeaderLabel' })`
    text-transform: capitalize;
    margin-right: auto;
    color: ${theme.star.unified.eventHeaderCaption.txtColor};
`);

export const EventHeaderCaption = withConfig(theme => styled('div', { label: 'EventHeaderCaption' })<EventHeaderExpandedPropsType>`
    align-items: center;
    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
    display: flex;
    justify-content: center;
    padding: 0;
    ${({ isExpandedSelectionLayout = false }): SerializedStyles =>
        isExpandedSelectionLayout === true
            ? css`
                  flex: 0 0 65px;
                  width: 65px;
                  min-width: 65px;

                  @media ${theme.star.mediaQuery.tablet} {
                      flex: 0 0 185px;
                      width: 185px;
                      min-width: 185px;
                      max-width: 185px;
                  }
              `
            : css`
                  width: 56px;
                  min-width: 0;
              `}
`);

export const EventHeaderCaptionName = styled('span', { label: 'EventHeaderCaptionName' })`
    color: currentcolor;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;


export const EventsTableInfo = styled('div', { label: 'EventsTableInfo' })`
    height: 100%;
    padding: 15px 5px 10px 5px;
    position: relative;
    text-align: center;
    flex: 1;
    justify-content: center;
    display: flex;
    align-items: center;
`;
